import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { requirePlatformRole } from '@/lib/route-guards';

// Admin role gate. Runs after the `_authed` gate; narrows further to
// members holding the `admin` role. Non-admins land back on /feed rather
// than the login screen so the UX stays inside the product surface.
// The route renders only an <Outlet/> — the intra-admin sidebar nav
// lives in `AdminShell`, mounted by each /admin/* view.
export const Route = createFileRoute('/_authed/admin')({
  beforeLoad: async ({ context }) => {
    await requirePlatformRole(context, {
      role: 'admin',
      bounceTo: () => redirect({ to: '/feed' }),
    });
  },
  component: Outlet,
});
